import { render, staticRenderFns } from "./ReprintPreviewDialog.vue?vue&type=template&id=0cb65c76&scoped=true&"
import script from "./ReprintPreviewDialog.vue?vue&type=script&lang=js&"
export * from "./ReprintPreviewDialog.vue?vue&type=script&lang=js&"
import style0 from "./ReprintPreviewDialog.vue?vue&type=style&index=0&id=0cb65c76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb65c76",
  null
  
)

export default component.exports